import * as React from 'react'
import { Box, TableCell, TableRow } from '@material-ui/core'
import { JsonEditor } from '../../../ui/JsonEditor'

interface InstallableDefinitionEditorProps {
  value: string
  onChange: (value: string) => void
}

export const InstallableDefinitionEditor: React.FC<InstallableDefinitionEditorProps> = ({ value, onChange }) => {
  return (
    <TableRow>
      <TableCell style={{ width: 200, minWidth: 200, whiteSpace: 'nowrap' }}>Definition JSON</TableCell>
      <TableCell style={{ width: '100%', maxWidth: 0 }}>
        <Box width='100%' style={{ overflowX: 'auto' }}>
          <JsonEditor value={value} onChange={onChange} height='260px' />
        </Box>
      </TableCell>
    </TableRow>
  )
}
